import { createReducer, on } from '@ngrx/store';
import { MembershipEntity } from '@resident-select/domain/membership';
import { GotMembershipByResidentEvent, GotAllMembershipsEvent, CanceledMembershipEvent } from './membership.events';

export interface MembershipState {
  entities: MembershipEntity[];
}

const initialState: MembershipState = {
  entities: []
};

export const membershipReducer = createReducer(
  initialState,
  on(GotMembershipByResidentEvent, (state, { entities }) => ({
    ...state,
    entities
  })),
  on(GotAllMembershipsEvent, (state, { entities }) => ({
    ...state,
    entities
  })),
  on(CanceledMembershipEvent, (state, { entities }) => ({
    ...state,
    entities
  }))
);
